import React, { FC } from 'react';
import { Typography } from '@getgo/chameleon-web/react';
import { IFormErrorMessageBox } from '../formInterface';

const FormErrorMessageBox: FC<IFormErrorMessageBox> = ({ errorMessage }) => (
  <div className="event-registration-form-error-message">
    <Typography color="text-error-01" variant="caption-small-02">
      {errorMessage}
    </Typography>
  </div>
);

export default FormErrorMessageBox;
